
    import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
    import { mapActions, mapState } from 'vuex';
    import Patient from '@/types/Patient';
    import { VForm } from '@/types/Components';
    import Warteliste from '@/types/Warteliste';

    @Component({
        computed: {
            ...mapState('globals', ['rules']),
            ...mapState('patient', ['patientData', 'loaders']),
        },
        methods: {
            ...mapActions('patient', ['waitPatient', 'getPatient', 'updateWaitPatient']),
        },
    })
    export default class WartelisteDetail extends Vue {
        @Prop() visible!: boolean;
        @Prop() warteliste!: Warteliste;
        @Prop() isEdit!: boolean;

        public $refs!: {
            form: VForm;
        };

        public patientData!: Patient;
        //public getPatient!: (payload: { patnr: number | null}) => void;
        public waitPatient!: (payload: { patnr: number; bemerkungen: string | null, folgetermin: string | null }) => void;
        public updateWaitPatient!: (payload: { aufnahme: string | null, patnr: number | null, bemerkungen: string | null, folgetermin: string | null }) => void;

        public isNew = true;
        public bemerkungen: string | null = null;
        public folgetermin: string | null = 'n';

        @Watch('visible')
        public onChangeVisible(visible: boolean): void {
            if (visible) {
                this.isNew = false;
                if (this.isEdit) {
                    this.bemerkungen = this.warteliste.bemerkungen;
                    this.folgetermin = this.warteliste.folgetermin;
                } else {
                    this.bemerkungen = '';
                    this.folgetermin = '';
                }
            }
        }

        public onClickSave(): void {
            if (!this.$refs.form.validate()) {
                return;
            }

            this.waitPatient({
                patnr: this.patientData.patnr as number,
                bemerkungen: this.bemerkungen,
                folgetermin: this.folgetermin
            });
        }

        public onClickUpdate(): void {
            this.updateWaitPatient({
                aufnahme: this.warteliste.aufnahme,
                patnr: this.warteliste.patnr,
                bemerkungen: this.bemerkungen,
                folgetermin: this.folgetermin
            });
        }
    }
